
/* styles */
require("!!../../../../../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-44e16068!sass-loader?sourceMap!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./header-hot-site.vue")

var Component = require("!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=script&index=0!./header-hot-site.vue"),
  /* template */
  require("!!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-44e16068!../../../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./header-hot-site.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/common/hotsite/components/header/header-hot-site.vue
// module id = 1982
// module chunks = 1